import globalEventBus from 'toxilibs/event_bus_queued.js'
import './goal/main.js'

let eventBus = globalEventBus('game flow')

let currentWorld

eventBus.on('world loaded', function (world) {
    currentWorld = world
})


eventBus.on('way completed', function () {
    currentWorld.freeze()

    eventBus.emit('player has done well')

    setTimeout(function () {
        eventBus.emit('player won')
    }, 1300)
})


eventBus.on('wrong way taken', function () {
    currentWorld.freeze()

    setTimeout(function () {
        eventBus.emit('player has done bad')
        eventBus.emit('player lost')
    }, 100)

    setTimeout(function () {
        currentWorld.reset()
    }, 1200)
})


